// extracted by mini-css-extract-plugin
export var filterIncDec = "_eb-0";
export var leftBorder = "_eb-1";
export var rightBorder = "_eb-2";
export var stringInput = "_eb-3";